import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import AccountDropdown from "../common/controls/AccountDropdown";
import DateUtil from "../../common/dateUtil";
import "react-datepicker/dist/react-datepicker.css";


const PreTradeFormAltInvest = (props) => {


  //  console.log(props.metadata);

  const node = useRef();

  const [showTxtFinName, setShowTxtFinName] = useState(false);
  const [limitStopDisabled, setLimitStopDisabled] = useState(true);

  const [dropdownOpen, setDropdownOpen] = useState(false);



  useEffect(() => {
    setShowTxtFinName(props.data.finInstituteId === "OTHER");
  }, [props.data.finInstituteId]);

  useEffect(() => {
    setLimitStopDisabled(
      props.data.orderType === "" || props.data.orderType === "Market Order"
    );
  }, [props.data.orderType]);


  const handleNumberField4DecimalChange = (e) => {
    if (/^\d+\.?\d{0,4}$/.test(e.target.value) || e.target.value === "") {
      props.handleChange(e);
    }
  };

  const handleNumberField2DecimalChange = (e) => {
    if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
      props.handleChange(e);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutsideDropdown);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, [dropdownOpen]);

  const handleClickOutsideDropdown = e => {
    console.log("clicking anywhere");
    if (node.current.contains(e.target)) {
      return;
    }
    setDropdownOpen(false);
  };


  return (

        <div className="form-items">

          <div className="form-columns">

            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.account ? "" : "warning"}`}>Select an Account :</label>
                <div className="wrapper-demo form-item-value">
                  <div ref={node} className={dropdownOpen ? "wrapper-dropdown-1 active" : "wrapper-dropdown-1"} onClick={p => setDropdownOpen(!dropdownOpen)}>

                    {props.data.account ?
                      props.data.account.accountNumber && props.data.account.brokerDealerName ? <><span>{props.data.account.accountNumber}</span>::<span>{props.data.account.brokerDealerName}</span></> : <span>Other...</span>
                      : (<span>Select an Account</span>)}
                    <span></span>
                    <AccountDropdown accounts = {props.metadata.accounts} selectionChanged={props.handleAccountSelectionChanged}/>
                   
                  </div>
                </div>
              </div>

              {props.data.account && !props.data.account.accountNumber &&
                <>
                  <div className="form-item">
                    <label className={`form-item-label required ${props.validation.finInstituteId ? "" : "warning"}`} htmlFor="finInstituteId">
                      Financial Institution :
                        </label>
                    <div className="form-item-value">
                      <select className="full-width" name="finInstituteId" value={props.data.finInstituteId} onChange={props.handleChange}>
                        <option key="" value="">
                          (Choose a Financial Institution)
                            </option>
                        {props.metadata.finInstitute.map((fin) => (
                          <option key={fin.id} value={fin.id}>
                            {fin.name}
                          </option>
                        ))}
                        <option key="OTHER" value="OTHER">
                          Other...
                            </option>
                      </select>
                      {showTxtFinName && (
                        <input
                          className="full-width"
                          type="text"
                          name="finInstitute"
                          id="txtFinName"
                          maxLength="250" 
                          value={props.data.finInstitute}
                          onChange={props.handleChange}
                          placeholder="Other Financial Institution"
                        />
                      )}
                    </div>
                  </div>

                  <div className="form-item">
                    <label
                      className={`form-item-label required ${props.validation.accountNumber ? "" : "warning"
                        }`}
                      htmlFor="accountNumber"
                    >
                      Account Number :
                        </label>
                    <input
                      className="form-item-value"
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      maxLength="50" 
                      value={props.data.accountNumber}
                      onChange={props.handleChange}
                    />
                  </div>


                </>

              }

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.securitySymbol ? "" : "warning"}`} htmlFor="securitySymbol">
                  Security Symbol :
                </label>
                <input className="form-item-value" type="text" id="securitySymbol" name="securitySymbol" maxLength="50" value={props.data.securitySymbol} onChange={props.handleChange}/>
              </div>



              <div className="form-item">
                <label className={`form-item-label required ${props.validation.securityDesc ? "" : "warning"}`} htmlFor="securityDesc">
                  Security Description :
              </label>
                <input className="form-item-value" type="text" id="securityDesc" name="securityDesc" maxLength="500" value={props.data.securityDesc} onChange={props.handleChange}/>
              </div>



            </div>

            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.tradeDate ? "" : "warning"}`} htmlFor="tradeDate">
                  Intended Trade Date :
              </label>

                <div className="form-item-value">
                  <DatePicker selected={DateUtil.toDate(props.data.tradeDate)} onChange={props.handleDateChange}/>
                </div>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.tradeAction? "" : "warning"}`}>
                  Trade Action :
                </label>
                <div className="form-item-value label-group">
                  <label>
                    <input type="radio" name="tradeAction" value="B" className="form-check-input" checked={props.data.tradeAction === "B"} onChange={props.handleChange}/>
                  Buy
                </label>
                  <label>
                    <input type="radio" name="tradeAction" value="S" className="form-check-input" checked={props.data.tradeAction === "S"} onChange={props.handleChange}/>
                  Sell
                </label>
                </div>
              </div>

              {props.data.tradeAction === "B" &&
              <>
              <div className="form-item">
                <label className={`form-item-label required ${props.validation.dollarAmount ? "" : "warning"}`} htmlFor="dollarAmount">
                  Investment Dollar Amount :
              </label>
              <input className="form-item-value" type="text" id="dollarAmount" name="dollarAmount" value={props.data.dollarAmount} onChange={handleNumberField4DecimalChange}/>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.investState ? "" : "warning"}`}>
                Initial/Existing :
                </label>
                <div className="form-item-value label-group">
                <div>
                  <label>
                    <input type="radio" name="investState" value="New" className="form-check-input" checked={props.data.investState === "New"} onChange={props.handleChange}/>
                  Initial Investment
                </label>
                </div>
                <div>
                <label>
                    <input type="radio" name="investState" value="Existing" className="form-check-input" checked={props.data.investState === "Existing"} onChange={props.handleChange}/>
                  Adding to an Existing Investment Amount
                </label>
                </div>
                </div>
              </div></>
              }
 
              {props.data.tradeAction === "S" &&
              <div className="form-item">
                <label className={`form-item-label required ${props.validation.liquidationAmount ? "" : "warning"}`} htmlFor="liquidationAmount">
                Liquidation Dollar Amount :
              </label>
                <input className="form-item-value" type="text" id="liquidationAmount" name="liquidationAmount" value={props.data.liquidationAmount} onChange={handleNumberField4DecimalChange}/>
              </div>
              }


            </div>

          </div>

        </div>

    );

};

export default PreTradeFormAltInvest;
